import EasyPassClient from './EasyPassClient';

class ConstantsClient {
  constructor(user) {
    this.easyPassClient = new EasyPassClient(user);
    this.rootUri = 'constants';
    this.easyPassRootUri = 'api/acvapi/v3';
    this.easyPassHeaders = {
      'json-naming-strategy': 'camel',
    };
  }

  get(key) {
    return this.easyPassClient.get(`${this.easyPassRootUri}/${this.rootUri}/${key}`);
  }
}

export default ConstantsClient;
